import Vapi from 'vuex-rest-api'
import http from 'src/http/index'
import { beforeRequestReset, createSuccess, deleteSuccess, updateSuccess } from 'components/utils/storeUtils'

const initialState = () => ({
  organisaties: null,
  organisatie: {},
  eigen_organisatie: {},
  project_klanten: null,
  project_klant: {},
  user: {},
  active_user: {},
  users: null,
  user_signature: {},
  user_signatures: null
})

const organisatieDepKeys = ['organisatie']

const management = new Vapi({
  axios: http.axios,
  baseURL: process.env.API_URL,
  queryParams: true,
  state: initialState()
})
  .get({
    action: 'GET_ORGANISATIES',
    property: 'organisaties',
    path: '/organisatie',
    beforeRequest: beforeRequestReset('organisaties', organisatieDepKeys, initialState())
  })
  .get({
    action: 'GET_ORGANISATIE',
    property: 'organisatie',
    queryParams: true,
    path: ({ id }) => `/organisatie/${id}`
  })
  .post({
    action: 'CREATE_ORGANISATIE',
    property: 'organisatie',
    path: '/organisatie',
    onSuccess: createSuccess('organisatie', 'organisaties')
  })
  .post({
    action: 'UPDATE_ORGANISATIE',
    property: 'organisatie',
    path: ({ id }) => `/organisatie/${id}`,
    onSuccess: updateSuccess('organisatie', 'organisaties')
  })
  .delete({
    action: 'DELETE_ORGANISATIE',
    property: 'organisatie',
    queryParams: true,
    path: ({ id }) => `/organisatie/${id}`,
    onSuccess: deleteSuccess('organisatie')
  })
  .get({
    action: 'GET_PROJECT_KLANTEN',
    property: 'project_klanten',
    queryParams: true,
    path: ({ id }) => `inventarisatie/project/${id}/project_klanten`,
    beforeRequest: beforeRequestReset('project_klanten', [], initialState())
  })
  .get({
    action: 'GET_PROJECT_KLANT',
    property: 'project_klant',
    queryParams: true,
    path: ({ id }) => `/project_klant/${id}`
  })
  .post({
    action: 'CREATE_PROJECT_KLANT',
    property: 'project_klant',
    path: '/project_klant',
    onSuccess: createSuccess('project_klant', 'project_klanten')
  })
  .post({
    action: 'UPDATE_PROJECT_KLANT',
    property: 'project_klant',
    path: ({ id }) => `/project_klant/${id}`,
    onSuccess: updateSuccess('project_klant', 'project_klanten')
  })
  .delete({
    action: 'DELETE_PROJECT_KLANT',
    property: 'project_klant',
    queryParams: true,
    path: ({ id }) => `/project_klant/${id}`,
    onSuccess: deleteSuccess('project_klant')
  })

  .get({
    action: 'GET_ACTIVE_USER',
    queryParams: true,
    property: 'active_user',
    path: '/user/me'
  })
  .get({
    action: 'GET_USERS',
    queryParams: true,
    property: 'users',
    path: '/user'
  })
  .get({
    action: 'GET_USER',
    property: 'user',
    queryParams: true,
    path: ({ id }) => `/user/${id}`
  })
  .post({
    action: 'CREATE_USER',
    property: 'user',
    path: '/user',
    onSuccess: createSuccess('user', 'users')
  })
  .post({
    action: 'UPDATE_USER',
    property: 'user',
    path: ({ id }) => `/user/${id}`,
    onSuccess: updateSuccess('user', 'users')
  })
  .delete({
    action: 'DELETE_USER',
    property: 'user',
    queryParams: true,
    path: ({ id }) => `/user/${id}`,
    onSuccess: deleteSuccess('user')
  })
  .get({
    action: 'GET_USER_SIGNATURES',
    queryParams: true,
    property: 'user_signatures',
    path: '/user_signature'
  })
  .get({
    action: 'GET_USER_SIGNATURE',
    property: 'user_signature',
    queryParams: true,
    path: ({ id }) => `/user_signature/${id}`
  })
  .post({
    action: 'CREATE_USER_SIGNATURE',
    property: 'user_signature',
    path: '/user_signature',
    onSuccess: createSuccess('user_signature', 'user_signatures')
  })
  .post({
    action: 'UPDATE_USER_SIGNATURE',
    property: 'user_signature',
    path: ({ id }) => `/user_signature/${id}`,
    onSuccess: updateSuccess('user_signature', 'user_signatures')
  })
  .delete({
    action: 'DELETE_USER_SIGNATURE',
    property: 'user_signature',
    queryParams: true,
    path: ({ id }) => `/user_signature/${id}`,
    onSuccess: deleteSuccess('user_signature')
  })
  .get({
    action: 'GET_CONTACT_PERSONEN',
    property: 'contact_personen',
    queryParams: true,
    path: ({ id }) => `/organisatie/${id}/contact_personen`
  })
  .get({
    action: 'GET_CONTACT_PERSOON',
    property: 'contact_persoon',
    queryParams: true,
    path: ({ id }) => `/contact_persoon/${id}`
  })
  .post({
    action: 'CREATE_CONTACT_PERSOON',
    property: 'contact_persoon',
    path: '/contact_persoon',
    onSuccess: createSuccess('contact_persoon', 'contact_personen')
  })
  .post({
    action: 'UPDATE_CONTACT_PERSOON',
    property: 'contact_persoon',
    path: ({ id }) => `/contact_persoon/${id}`,
    onSuccess: updateSuccess('contact_persoon', 'contact_personen')
  })
  .delete({
    action: 'DELETE_CONTACT_PERSOON',
    property: 'contact_persoon',
    path: ({ id }) => `/contact_persoon/${id}`,
    onSuccess: deleteSuccess('contact_persoon', 'contact_personen')
  }).getStore()

management.mutations.RESET_MANAGEMENT_STATE = (state) => {
  const initial = initialState()
  for (const key in initial) {
    if (Object.prototype.hasOwnProperty.call(initial, key)) {
      state[key] = initial[key]
    }
  }
}

export default management
